import React from 'react';
import style from './Loading2.module.css'

export default function Loading3 () {

    return (
        <div className={style.center2}>
            <div className={style.ring2}> 
                {/* <span> Loading ... </span> */}
            </div>
        </div>
    )

}